







































































import { Component, Mixins, Inject } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import HasValidation from "@/mixins/HasValidation";
import { ValidationObserver } from "vee-validate";
import { ICompany } from "@/models/companies";
import { IAddress } from "@/models/addresses";
import { DataModules } from "@/store/modules/data";
import { IInvoice } from "@/models/invoices";
import {
  IInvoiceProvider,
  IInvoiceProviderMethods
} from "@/models/providers/invoice";

@Component({
  components: {
    "client-address-select": () =>
      import("@/components/app/global/fields/clientAddressSelect.vue"),
    "client-company-select": () =>
      import("@/components/app/global/fields/clientCompanySelect.vue")
  }
})
export default class RegenerateInvoiceModal extends Mixins(
  RequestPromises,
  HasValidation
) {
  // Inject
  @Inject({ from: "invoiceProvider" })
  public readonly $invoiceProvider!: () => IInvoiceProvider;
  @Inject({ from: "invoiceProviderMethods" })
  public readonly $invoiceMethods!: IInvoiceProviderMethods;
  // Refs
  public declare $refs: {
    observer: InstanceType<typeof ValidationObserver>;
  };
  // Data
  public isProcessing = false;
  public recalculateTax = false;
  public form: {
    address_id: IAddress["id"] | null;
    company_id: ICompany["id"] | null;
    apply_contract_changes: boolean;
  } = {
    address_id: null,
    company_id: null,
    apply_contract_changes: false
  };
  // Life-cycle methods
  public created() {
    this.$set(this, "form", {
      ...this.form,
      address_id: this.$_.get(this.invoice, "client_address.id", null),
      company_id: this.$_.get(this.invoice, "client_company.id", null)
    });
  }
  // Computed
  public get $invoice() {
    return this.$invoiceProvider();
  }
  public get invoice() {
    return this.$invoice.invoiceDataContent;
  }
  public get objectChanged() {
    return this.form.company_id ? this.$t("_.company") : this.$t("_.address");
  }
  // Methods
  public regenerate() {
    return this.$store
      .dispatch(`data/${DataModules.INVOICES}/regenerateInvoice`, {
        invoiceId: this.$_.get(this.invoice, "id"),
        data: this.$_.omit(this.form, ["apply_contract_changes"])
      })
      .then(() => {
        return this.$invoiceMethods.reloadData();
      });
  }

  public recalculate() {
    return this.$store
      .dispatch(`data/${DataModules.INVOICES}/recalculateInvoice`, {
        invoiceId: this.$_.get(this.invoice, "id"),
        data: this.form
      })
      .then((invoice: IInvoice) => {
        return this.$router
          .push(
            this.$store.getters[`data/${DataModules.INVOICES}/getRoute`](
              invoice.id,
              invoice.client_id
            )
          )
          .catch((this.$router as any).handleFailure);
      });
  }

  public async validateBeforeSubmit() {
    try {
      this.isProcessing = true;
      await this[this.recalculateTax ? "recalculate" : "regenerate"]();
      this.$emit("close");
      this.$buefy.toast.open({
        message: this.$t("_.object_successfully_updated", {
          object: this.$t("_.invoice")
        }) as string
      });
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }
}
